import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{body-class "groups-new-page"}}

<section>
  <h1>{{i18n "admin.groups.new.title"}}</h1>

  <hr />

  <form class="groups-form form-vertical">
    <GroupsFormProfileFields @model={{this.model}} @disableSave={{this.saving}}>
      <div class="control-group">
        <label class="control-label" for="owner-selector">{{i18n
            "admin.groups.add_owners"
          }}</label>

        <EmailGroupUserChooser
          @id="owner-selector"
          @value={{this.splitOwnerUsernames}}
          @onChange={{action "updateOwnerUsernames"}}
          @options={{hash filterPlaceholder="groups.selector_placeholder"}}
          class="input-xxlarge"
        />
      </div>

      <div class="control-group">
        <label class="control-label" for="member-selector">{{i18n
            "groups.members.title"
          }}</label>

        <EmailGroupUserChooser
          @id="member-selector"
          @value={{this.splitUsernames}}
          @onChange={{action "updateUsernames"}}
          @options={{hash filterPlaceholder="groups.selector_placeholder"}}
          class="input-xxlarge"
        />
      </div>
    </GroupsFormProfileFields>

    <GroupsFormMembershipFields @model={{this.model}} />
    <GroupsFormInteractionFields @model={{this.model}} />

    <div class="control-group buttons">
      <DButton
        @action={{this.save}}
        @disabled={{this.saving}}
        @label="admin.groups.new.create"
        type="submit"
        class="btn-primary group-form-save"
      />

      <LinkTo @route="groups">
        {{i18n "cancel"}}
      </LinkTo>
    </div>
  </form>
</section>
*/
{
  "id": "nPd13wYJ",
  "block": "[[[1,[28,[35,0],[\"groups-new-page\"],null]],[1,\"\\n\\n\"],[10,\"section\"],[12],[1,\"\\n  \"],[10,\"h1\"],[12],[1,[28,[35,1],[\"admin.groups.new.title\"],null]],[13],[1,\"\\n\\n  \"],[10,\"hr\"],[12],[13],[1,\"\\n\\n  \"],[10,\"form\"],[14,0,\"groups-form form-vertical\"],[12],[1,\"\\n    \"],[8,[39,2],null,[[\"@model\",\"@disableSave\"],[[30,0,[\"model\"]],[30,0,[\"saving\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"control-label\"],[14,\"for\",\"owner-selector\"],[12],[1,[28,[35,1],[\"admin.groups.add_owners\"],null]],[13],[1,\"\\n\\n        \"],[8,[39,3],[[24,0,\"input-xxlarge\"]],[[\"@id\",\"@value\",\"@onChange\",\"@options\"],[\"owner-selector\",[30,0,[\"splitOwnerUsernames\"]],[28,[37,4],[[30,0],\"updateOwnerUsernames\"],null],[28,[37,5],null,[[\"filterPlaceholder\"],[\"groups.selector_placeholder\"]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"control-label\"],[14,\"for\",\"member-selector\"],[12],[1,[28,[35,1],[\"groups.members.title\"],null]],[13],[1,\"\\n\\n        \"],[8,[39,3],[[24,0,\"input-xxlarge\"]],[[\"@id\",\"@value\",\"@onChange\",\"@options\"],[\"member-selector\",[30,0,[\"splitUsernames\"]],[28,[37,4],[[30,0],\"updateUsernames\"],null],[28,[37,5],null,[[\"filterPlaceholder\"],[\"groups.selector_placeholder\"]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,6],null,[[\"@model\"],[[30,0,[\"model\"]]]],null],[1,\"\\n    \"],[8,[39,7],null,[[\"@model\"],[[30,0,[\"model\"]]]],null],[1,\"\\n\\n    \"],[10,0],[14,0,\"control-group buttons\"],[12],[1,\"\\n      \"],[8,[39,8],[[24,0,\"btn-primary group-form-save\"],[24,4,\"submit\"]],[[\"@action\",\"@disabled\",\"@label\"],[[30,0,[\"save\"]],[30,0,[\"saving\"]],\"admin.groups.new.create\"]],null],[1,\"\\n\\n      \"],[8,[39,9],null,[[\"@route\"],[\"groups\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,1],[\"cancel\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"body-class\",\"i18n\",\"groups-form-profile-fields\",\"email-group-user-chooser\",\"action\",\"hash\",\"groups-form-membership-fields\",\"groups-form-interaction-fields\",\"d-button\",\"link-to\"]]",
  "moduleName": "discourse/templates/groups/new.hbs",
  "isStrictMode": false
});